export default __webpack_public_path__ + "static/media/Logo_let.58532b61.png";